/*
 * IMPORTS
 */
import { gql } from "@apollo/client"; // Npm: Apollo client for handling graphql request.

/*
 * EXPORTS
 */
export default gql`
  mutation ScriptCreateMutation($name: String!, $scriptCode: String!) {
    ScriptCreate(name: $name, scriptCode: $scriptCode) {
      id
      message
      name
      createdAt
      scriptCode
      status
    }
  }
`;
